import { useMemo } from 'react'
import { ModalSmallCentered, ButtonsModalSmallCentered } from '../../../../../../../../../../../../baseComponents/Modal'
import TwinTrans from '../../../../../../../../../../../../baseComponents/TwinTrans'
import CustomSelect from '../../../../../../../../../../../../forms/CustomSelect'
import TwinForm from '../../../../../../../../../../../../forms/TwinForm'
import { TwinDictionary } from '../../../../../../../../../../../../utils/globals/dictionary'
import { SetEditDeleteModalTy } from '../../../../../../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getConfigParam } from '../../../../../../../../../../../../utils/reducers/getters'
import { InputHidden } from '../../../../../../../../../../../../forms/Input'



interface ModalUpdateWorkSheetProductsProps {
    OrderId: string
    onSubmit: () => void
    setOpenModal: SetEditDeleteModalTy
}

const ModalUpdateWorkSheetProducts: React.FC<ModalUpdateWorkSheetProductsProps> = ({ OrderId, onSubmit, ...logic }) => {
    const { t } = useTwinTranslation()
    const memoDefaultWorkSheetType = useMemo(() => getConfigParam('workSheetTypeByDefault'), [])
    const dictCreateType: TwinDictionary = {
        'allProducts': { name: t('withAllProducts', 'Con todos los productos') },
        'selectedProducts': { name: t('fromSelectedProducts', 'A partir de los productos seleccionados') },
        'onlyMain': { name: t('onlyMainProducts', 'Solo productos principales') },
        'onlyAddons': { name: t('onlyAddons', 'Solo complementos') },
    }
    return (
        <ModalSmallCentered opened={true} setOpened={() => logic.setOpenModal(null)} onClickOut={false} className='flex_height'>
            <TwinForm action={'/api/app/order/sell/sellOrder/updateWorkSheetSellOrder'} onSubmit={onSubmit} className='flex flex-auto flex-col justify-between ' triggerErrors={false} triggerSuccess={false}>
                <h2 className='mb-20'>
                    <TwinTrans transKey={'sellOrderHasAssociatedWorkSheet'}>Este pedido tiene una hoja de trabajo asociada</TwinTrans>
                </h2>
                <span className='mt-10 mb-30'><TwinTrans transKey={'doYouWantToUpdateWorkSheetProducts'}>¿Quieres actualizar los productos en la hoja de trabajo?</TwinTrans></span>
                <CustomSelect label={t('workSheetType', 'Tipo de hoja de trabajo')} items={dictCreateType} value={memoDefaultWorkSheetType || 'allProducts'} className='mb-20' name='typeWorkSheet'/>
                <InputHidden name='SellOrderId' value={OrderId} />
                <ButtonsModalSmallCentered confirmText={t('update', 'Actualizar')} setOpened={() => { }} onCancel={onSubmit} />
            </TwinForm>
        </ModalSmallCentered>
    )
}

export default ModalUpdateWorkSheetProducts